const user_management = {
	dialog: {
		add_user_first_impersonate: {
			alert:
				"To add a user, you must first impersonate an administrator of debtor <strong>{{debtor_code}}</strong>.",
			to_impersonate_page_button: "Go to Impersonate",
		},
		block: {
			description: "Are you sure you want to block user <strong>{{username}}</strong>?",
			success_alert: "User blocked successfully!",
			title: "Block User",
		},
		deblock: {
			description: "Are you sure you want to unblock user <strong>{{username}}</strong>?",
			success_alert: "User unblocked successfully!",
			title: "Unblock User",
		},
		delete: {
			delete_last_admin:
				"I am aware that in doing so, I am deleting the last admin user of debtor <strong>{{debtor}}</strong>.",
			description: "Are you sure you want to delete user <strong>{{username}}</strong>?",
			otp_invalid: "Invalid 2FA code!",
			otp_not_enabled:
				"Before you can delete users, you must enable 2FA (Two-Factor Authentication) first.",
			success_alert: "User deleted successfully!",
			title: "Delete User",
		},
		disable_otp: {
			description: "Are you sure you want to disable 2FA for <strong>{{user}}</strong>?",
			messages: {
				success: "2FA successfully removed for <strong>{{user}}</strong>!",
			},
			otp_first: "First activate 2FA before you can disable it for a user.",
			otp_invalid: "Incorrect 2FA code!",
			otp_not_enabled: "2FA is not enabled for this user",
			submit_button: "Disable",
			title: "Disable 2FA",
		},
		impersonate: {
			description: "Are you sure you want to impersonate user <strong>{{username}}</strong>?",
			otp_invalid: "Invalid 2FA code!",
			otp_not_enabled:
				"Before you can impersonate users, you must enable 2FA (Two-Factor Authentication) first.",
			title: "Impersonate User",
		},
	},
	membership_type: {
		business: "Business",
		label: "Select debtor type",
		private: "Private",
	},
	show_disabled: "Show Deleted Users",
	table: {
		body: {
			buttons: {
				block: "Block",
				deblock: "Unblock",
				impersonate: "Impersonate",
			},
			otp: {
				disabled: "2FA disabled",
				enabled: "2FA enabled",
			},
		},
		headers: {
			categories: "Labels",
			company: "Company Name",
			debtor_code: "Debtor Number",
			email_address: "Email Address",
			language: "Language",
			membership_type: "Account Type",
			otp: "2FA",
			phone_number: "Phone Number",
			user_id: "User ID",
			username: "Username",
		},
	},
	title: "Users",
};

export default user_management;
